import { render, staticRenderFns } from "./QuestionTypeVideo.vue?vue&type=template&id=4c1431ab"
import script from "./QuestionTypeVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeVideo.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeVideo.vue?vue&type=style&index=0&id=4c1431ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports